import {HIDE_MODAL} from "../types";

const modalDismiss= () => {
    return ({type: HIDE_MODAL});
};
export default modalDismiss;